
const billsType = {
  BILLS_TABLE_STATE_SET: 'BILLS/TABLE_STATE_SET',
  BILLS_TABLE_STATE_RESET: 'BILLS/TABLE_STATE_RESET',
};
export default billsType;